(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/dashed-frame/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/dashed-frame/assets/prescript.js');
'use strict';

svs.tb_ui_react = svs.tb_ui_react || {};
svs.tb_ui_react.dashed_frame = svs.tb_ui_react.dashed_frame || {};

 })(window);